// extracted by mini-css-extract-plugin
export default {"container":"style_container__FEQ+0","title_row":"style_title_row__aqOmT","text_content":"style_text_content__SJXxm"};